import React from 'react';

export default function Logo({ size = 32, idPrefix = 'logo' }) {
  const neonId = `${idPrefix}-neon`;
  const glowId = `${idPrefix}-glow`;

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={neonId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00F5FF" />
          <stop offset="50%" stopColor="#7C3AED" />
          <stop offset="100%" stopColor="#FF2E88" />
        </linearGradient>
        <filter id={glowId}>
          <feGaussianBlur stdDeviation="2.5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <rect width="64" height="64" rx="14" fill="#0B0F1A" />
      <rect x="8" y="8" width="48" height="48" rx="12" fill="none" stroke={`url(#${neonId})`} strokeWidth="2.5" filter={`url(#${glowId})`} />
      <circle cx="32" cy="32" r="18" fill={`url(#${neonId})`} opacity="0.12" />
      <path
        d="M42 24
           C38 20, 26 20, 24 26
           C22 31, 27 32, 33 33
           C39 34, 40 38, 36 40
           C32 42, 24 41, 22 38"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="4"
        strokeLinecap="round"
        filter={`url(#${glowId})`}
      />
      <circle cx="44" cy="40" r="2.5" fill="#00F5FF" />
    </svg>
  );
}
